import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Check } from "../../components/svg/Auth/Auth";
import { useAuth } from "../../api/auth";
import OTPInput from "../../components/input/OTPInput";
import { AuthLayout } from "../../layout/AuthLayout";
import { Loader } from "../../components/loader/Loader";

function VerifyOtp() {
  const {
    handleResendOtp,
    handleVerifyOtp,
    email,
    setEmail,
    loading,
    otp,
    setOtp,
  } = useAuth();

  const search = useLocation();
  const searchParams = new URLSearchParams(search.search);

  useEffect(() => {
    if (searchParams) {
      setEmail(searchParams.get("mobile"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  useEffect(() => {
    if (otp.length === 4) {
      handleVerifyOtp();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otp]);

  return (
    <AuthLayout>
      <div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2, delay: 0.5 }}
          className="flex flex-col items-center justify-center rounded-b-[50px]"
        >
          <img
            className="max-w-[102px] object-contain mt-32 mb-10"
            src="/image/Hand-3d.png"
            alt="banner"
            loading="lazy"
          />
          <motion.h3
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.6 }}
            className="text-2xl tracking-tight font-medium text-center text-black mx-0"
          >
            OTP Verification
          </motion.h3>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.7 }}
            className="text-base text-black mt-1"
          >
            Enter the OTP sent to <span className="font-medium">{email}</span>
          </motion.p>
          <div className="container grid place-items-center pb-12">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.7 }}
              className="mt-8 mb-4 w-full px-1"
            >
              <OTPInput getPin={(val) => setOtp(val)} />
              <div className="flex items-center justify-between mt-5">
                <div className="flex items-center gap-1.5">
                  <Check />
                  <p className="text-xs text-black">Code verified</p>
                </div>
                {loading ? (
                  <Loader
                    width={"35px"}
                    height={"25px"}
                    color={"#2741D6"}
                    type="bubbles"
                  />
                ) : (
                  <button
                    onClick={() => handleResendOtp()}
                    className="text-primary-main text-xs"
                  >
                    Resend OTP
                  </button>
                )}
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </AuthLayout>
  );
}

export default VerifyOtp;
